<template>
  <section class="p-2">
    <div>
      <v-form>
        <v-card class="">
          <v-card-title class="d-flex justify-space-between p-0 m-0">
            <div class="ps-2 headingFontsize">Bank Branch</div>
            <div>
              <bread-crumb
                :bread-crumbs="['Partner Summary', 'Bank List', 'Bank Branch']"
              />
            </div>
          </v-card-title>
          <v-divider class="p-0 m-0 primary--text"></v-divider>
          <!-- <v-toolbar flat dense>
            <v-toolbar-title>Bank Branch</v-toolbar-title>
          </v-toolbar> -->
          <!-- <div style="border:solid 1px;color:grey" class="ms-4 me-4"></div> -->
          <!-- <v-divider   style="border: solid 1px;color: green;  "></v-divider> -->
          <v-card-text>
            <v-row class="mt-2 ms-1 me-1">
              <v-col cols="12" md="3">
                <label class="labelFontsize mb-0">Branch Name</label>
                <v-text-field
                  outlined
                  dense
                  class="rounded"
                  placeholder="Branch Name"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <label class="labelFontsize mb-0">City</label>
                <v-text-field outlined dense class="rounded" placeholder="City">
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <label class="labelFontsize mb-0">State</label>
                <v-text-field
                  outlined
                  dense
                  class="rounded"
                  placeholder="State"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <label class="labelFontsize mb-0">District</label>
                <v-text-field
                  outlined
                  dense
                  class="rounded"
                  placeholder="District"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row class="ms-1 me-1">
              <v-col cols="12" md="3">
                <label class="labelFontsize mb-0">Address</label>
                <v-text-field
                  outlined
                  dense
                  class="rounded"
                  placeholder="Address"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <label class="labelFontsize mb-0">Contact</label>
                <v-text-field
                  outlined
                  dense
                  class="rounded"
                  placeholder="Contact"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <label class="labelFontsize mb-0">External Code 1</label>
                <v-text-field
                  outlined
                  dense
                  class="rounded"
                  placeholder="External Code 1"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <label class="labelFontsize mb-0">External Code 2</label>
                <v-text-field
                  outlined
                  dense
                  class="rounded"
                  placeholder="External Code 2"
                >
                </v-text-field>
              </v-col>
            </v-row>

            <div class="row">
              <div
                class="col-md-12"
                style="display: flex; justify-content: end"
              >
                <v-btn depressed  small class="text-capitalize me-3 mb-10" color="primary"
                  ><v-icon small>mdi-content-save-plus-outline</v-icon>Add</v-btn
                >
                <v-btn depressed 
                  small
                  class="text-capitalize me-5 mb-10"
                  color="primary"
                  outlined
                  ><v-icon small class="me-2">mdi-close-circle-outline</v-icon>Cancel</v-btn
                >
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-form>
    </div>
  </section>
</template>
<script>
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
export default {
  data: () => ({}),
  components: {
    BreadCrumb,
  },
};
</script>

<style lang="scss" scoped>
@import "@/global.scss";
.required:after {
  content: " *";
  color: red;
}
</style>
